'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoUmbrella = function IoUmbrella(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.9 22.5z m-18.8 0z m10.7-18.7c9 0.7 16.2 8.5 16.2 17.8v0.9c-0.3-2-2-4.1-4.1-4.1-2.2 0-4 1.8-4 4.1 0-2.3-1.8-4.1-4.1-4.1s-3.8 1-4.1 3.6v10.5c0 1.3-0.4 2.6-1.4 3.5s-2.2 1.5-3.6 1.5c-2.7 0-4.9-2.3-4.9-5 0-0.7 0.6-1.2 1.3-1.2s1.2 0.5 1.2 1.2c0 1.4 1.1 2.5 2.4 2.5 1.5 0 2.5-1.1 2.5-2.5v-10.5c0-1.8-2-3.6-4-3.6-2.3 0-4.1 1.8-4.1 4.1 0-2.3-1.8-4.1-4-4.1-2.2 0-3.9 2.1-4.1 4.1v-1.4c0-9.2 7.2-16.6 16.2-17.3v0c0-0.8 0.6-1.3 1.3-1.3s1.2 0.5 1.2 1.3v0z' })
        )
    );
};

exports.default = IoUmbrella;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/umbrella.js
// module id = 2751
// module chunks = 0